import React, { useState, useEffect, useRef } from 'react';
import { Alert, Button, LoadingButton, ModalBody, ModalFooter, Typography, FormController, FormLabel, Radio, RadioGroup, SelectionControlLabel, } from '@one-thd/sui-atomic-components';
import { ERR_PRO_UPGRADE } from '../../../../constants/response-error-messages';
import { setOverlayEvent } from '../../../../utils/analytics';
import { setCancelEvent, setVerificationCodeSendAndResendAnalytics, } from '../../../../utils/convert-to-pro-analytics';
export var VerifyMethodModalContent = function (_a) {
    var onCancel = _a.onCancel, onConfirm = _a.onConfirm, maskedPhone = _a.maskedPhone, emailId = _a.emailId;
    var _b = useState(function () { return (maskedPhone ? null : 'email'); }), verificationMethod = _b[0], setVerificationMethod = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var isMounted = useRef(false);
    useEffect(function () {
        isMounted.current = true;
        setOverlayEvent('convert to pro verify your identity');
        return function () {
            isMounted.current = false;
        };
    }, []);
    var onSend = function () {
        if (!verificationMethod) {
            return;
        }
        setVerificationCodeSendAndResendAnalytics(verificationMethod === 'sms' ? 'text' : verificationMethod);
        setIsLoading(true);
        onConfirm(verificationMethod)
            .catch(function () {
            setError(ERR_PRO_UPGRADE);
        })
            .finally(function () {
            if (isMounted.current) {
                setIsLoading(false);
            }
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalBody, null,
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-8" },
                React.createElement(React.Fragment, null, maskedPhone ? (React.createElement(React.Fragment, null,
                    React.createElement(Typography, { variant: "body-base" }, "Before converting to a Pro Xtra account, we need to confirm your identity by sending a one-time verification code."),
                    React.createElement(FormController, null,
                        React.createElement(FormLabel, { id: "verification-radio-buttons-group-label" }, "How should we send the verification code?"),
                        React.createElement(RadioGroup, { "aria-labelledby": "verification-radio-buttons-group-label", name: "verification-radio-buttons-group" },
                            React.createElement(SelectionControlLabel, null,
                                React.createElement(React.Fragment, null,
                                    React.createElement(Radio, { value: "sms", checked: verificationMethod === 'sms', onChange: function () {
                                            setVerificationMethod('sms');
                                        } }),
                                    React.createElement(Typography, { variant: "body-base", component: "span" },
                                        React.createElement(Typography, { weight: "bold", component: "span" },
                                            "Text:",
                                            ' '),
                                        maskedPhone))),
                            React.createElement(SelectionControlLabel, null,
                                React.createElement(React.Fragment, null,
                                    React.createElement(Radio, { value: "phone", checked: verificationMethod === 'phone', onChange: function () { return setVerificationMethod('phone'); } }),
                                    React.createElement(Typography, { variant: "body-base", component: "span" },
                                        React.createElement(Typography, { weight: "bold", component: "span" },
                                            "Phone Call:",
                                            ' '),
                                        maskedPhone))),
                            emailId && (React.createElement(SelectionControlLabel, null,
                                React.createElement(React.Fragment, null,
                                    React.createElement(Radio, { value: "email", checked: verificationMethod === 'email', onChange: function () { return setVerificationMethod('email'); } }),
                                    React.createElement(Typography, { variant: "body-base", component: "span" },
                                        React.createElement(Typography, { weight: "bold", component: "span" },
                                            "Email:",
                                            ' '),
                                        emailId)))))))) : (React.createElement(React.Fragment, null,
                    React.createElement(Typography, { variant: "body-base", component: "p" }, "Before converting a Pro Xtra account, we need to confirm your identity by sending a one-time verification code to your email address:"),
                    React.createElement(Typography, { weight: "bold", component: "p" }, emailId)))),
                error && React.createElement(Alert, { status: "error" }, error.message))),
        React.createElement(ModalFooter, null,
            React.createElement("div", { className: "sui-flex sm:sui-flex-row-reverse sui-flex-wrap sm:sui-flex-nowrap sui-gap-6 sui-w-full" },
                React.createElement(LoadingButton, { fullWidth: true, variant: "primary", disabled: !verificationMethod, onClick: onSend, loading: isLoading, "data-testid": "send-code-btn" }, "Send Code"),
                React.createElement(Button, { fullWidth: true, variant: "secondary", onClick: function () {
                        setCancelEvent("convert to pro xtra overlay: verify your identity: cancel");
                        onCancel();
                    }, "data-testid": "verify-method-cancel-btn" }, "Cancel")))));
};
VerifyMethodModalContent.displayName = 'VerifyMethodModalContent';
